// NOTE: These values must match the enum values on the server side:
export const ALL_PLAYER_BLOCKING_TYPES = ['chat', 'private_messages'];
export function isPlayerBlockingType(str) {
    return typeof str === 'string' && ALL_PLAYER_BLOCKING_TYPES.includes(str);
}
export const BLOCKING_TYPE_LABELS = {
    chat: 'Chat',
    private_messages: 'Direct Messages'
};
